<div class="d-flex bg-body-tertiary INN-h100vh">
  <main class="form-signin w-100 m-auto rounded-4 card shadow m-5">
    <img class="mb-2 ms-2 mt-4 col-6 text-center" src="../../../assets/svg/usuario-no-reconocido-fa.svg" alt="">
    <div class="card border-0">
      <img src="../../../assets/svg/icono-de-candado.jpg" class="card-img-top img-fluid mt-4" alt="Imagen de login">
      <div class="card-body">
        <h4 class="mb-4 fw-normal text-center text-secondary ">Lo sentimos</h4>
        <p class="mb-4 fw-normal text-center ">No cuentas con los permisos necesarios para acceder. Favor de
          contactar a un administrador.</p>

      </div>
    </div>
  </main>
</div>